import { Controller } from "@hotwired/stimulus"
import { patch } from '../../../helpers/request_helpers'

export default class extends Controller {
  static targets = ['prefsText', 'submit']

  static values = { allPrefNames: Array }

  fillAllPrefs() {
    this.prefsTextTarget.value = this.allPrefNamesValue.join(' ')
  }

  async submit() {
    this.submitTarget.disabled = true

    try {
      await patch(this.element.action, { body: new FormData(this.element) })
    } catch {
      this.submitTarget.disabled = false
    }
  }
}
